// import refundVerify from './component/order/refundVerify'
export default {
  className: 'refundOrder',
  title: '退款订单',
  fields: [
    // {
    //   name: 'refundOrderId'
    // },
    {
      name: 'order',
      width: 180,
      searchKey: ['orderId'],
      render: (record) => {
        return record && record.order && record.order.orderId
      },
      listWhere: (where) => {
        where.state = {
          $ne: 'bePaid'
        }
        where.type = 'shopping'
      }
    },
    {
      name: 'goodsObj',
      note: '商品信息',
      render: (record) => {
        let string = ''
        if (record.goodsObj) {
          for (let i in record.goodsObj) {
            let item = record.goodsObj[i]
            if (Number(i) === record.goodsObj.length - 1) {
              string += `${item.name}(${item.count})`
            } else {
              string += `${item.name}(${item.count})、`
            }
          }
        }
        return string
      }
    },
    {
      name: 'money'
    },
    {
      name: 'orderPayType',
      note: '订单支付方式',
      render: (record) => {
        return record && record.order && record.order.paytype === 'walletPay' ? '钱包支付' : '微信支付'
      }
    },
    {
      name: 'user',
      render: (record) => {
        return `${record.user.nickName}-${record.user.phone}`
      }
    }
  ],
  search: [
    {
      name: 'order'
    },
    {
      name: 'user',
      listWhere: (where) => {
        where.isAdmin = {
          $ne: true
        }
        if (!where.phone) {
          where.phone = {
            $exists: true
          }
        }
      }
    },
    'paytype'
  ],
  action: false
}
